__webpack_require__.p = "/buzzbingo_bingo-theme/js/app-out/";